// @flow

import * as React from 'react';

type Props = {
  /**
   * This prop determines whether to render the success icon or the fail icon.
   */
  success: ?boolean,
  /**
   * This prop is passed to set the correct data-testid for each icon.
   */
  testid: ?string
};

class StatusIcon extends React.PureComponent<Props> {
  render() {
    return (
      <div>
        {!!this.props.success ? (
          <i
            className="material-icons md-18 check"
            data-testid={this.props.testid}
          >
            check
          </i>
        ) : (
          <i
            className="material-icons md-18 close"
            data-testid={this.props.testid}
          >
            close
          </i>
        )}
      </div>
    );
  }
}

export default StatusIcon;
